import BaseLevelScene from './BaseLevelScene';

export default class ChurchHillScene extends BaseLevelScene {
  tileWidth: integer = 16;
  tileHeight: integer = 16;
  constructor() {
    super('Church Hill');
  }

  preload() {

    // Preload base level
    this.preloadBaseLevel();

    // load the train PNG file
    this.load.image('train_tiles', 'assets/sourceImages/WhenItTrainsItPours.png');

    // load the catacomb PNG file
    this.load.image('catacomb_tiles', 'assets/sourceImages/mainlevbuild.png')

    // load the JSON map
    this.load.tilemapTiledJSON(
      'church_hill_tilemap',
      'assets/scenes/ChurchHill.json'
    );
  }

  create() {
    // 👌 sanity check by displaying the entire tileset image
    // this.add.image(0, 0, 'sewer_tiles');

    // create the Tilemap
    this.map = this.make.tilemap({ key: 'church_hill_tilemap' });

    // add the tileset  images we are using
    const baseTileset = this.map.addTilesetImage('catacomb', 'catacomb_tiles');
    const trainTileset = this.map.addTilesetImage('train', 'train_tiles');

    // create the layers we want in the right order
    const floor = this.map.createLayer('BaseLayer', baseTileset);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(floor);

    // add any additional textures over the base layer
    const textures = this.map.createLayer('Textures', baseTileset);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(textures);

    // train and tracks layer will be on top of base layer
    const tracks = this.map.createLayer('Tracks', trainTileset);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(tracks);

    // train and tracks layer will be on top of base layer
    const train = this.map.createLayer('Train', trainTileset);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(train);

    // create base level
    this.createBaseLevel(0.4, 4);
  }
}
